import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {IRadioBtnItemModel} from '../iradio-btn-item';
import {ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'li3-radio-btns-form-item',
  templateUrl: './radio-btns-form-item.component.html',
  styleUrls: ['./radio-btns-form-item.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioBtnsFormItemComponent)
    }
  ]
})
export class RadioBtnsFormItemComponent implements OnInit, ControlValueAccessor {
  @Input() frmGroup: FormGroup;
  @Input() data: IRadioBtnItemModel[];
  @Input() value: string;

  constructor() {
  }

  ngOnInit() {
  }

  propagateChange = function (_: any) {
  };

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
  }

  writeValue(value: any) {
    this.value = value;
  }

  onChange(value) {
    this.value = value;
    this.propagateChange(value);
  }
}
